import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFileExport, FaChartPie } from 'react-icons/fa';
import DashboardLayout from '../components/DashboardLayout';
import { hasModulePermission } from '../utils/permissions';
import '../assets/styles/reports.css';

const Reports = () => {
  const navigate = useNavigate();

  const cards = [
    hasModulePermission('reports.overview', 'view') && {
      key: 'employee-overview',
      title: 'Employee Overview',
      description: 'Review an at-a-glance summary of your workforce performance.',
      icon: <FaChartPie size={42} />,
      action: () => navigate('/reports/overview'),
    },
    hasModulePermission('reports.employee_export', 'view') && {
      key: 'export-employees',
      title: 'Export Employee Details',
      description: 'Download employee information with custom columns and filters.',
      icon: <FaFileExport size={42} />,
      action: () => navigate('/reports/export/employees'),
    },
  ].filter(Boolean);

  return (
    <DashboardLayout title="Report">
      <div className="reports-page">
        <div className="mb-4">
          <h2 className="fw-semibold mb-1">Report</h2>
          <p className="text-muted mb-0">Select a report card to continue.</p>
        </div>
        {cards.length === 0 ? (
          <div className="text-muted">No reports assigned to your role.</div>
        ) : (
          <div className="reports-card-grid">
            {cards.map((card) => (
              <button key={card.key} type="button" className="report-card" onClick={card.action}>
                <div className="report-card-icon">{card.icon}</div>
                <h5 className="report-card-title">{card.title}</h5>
                <p className="report-card-description">{card.description}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Reports;
